import { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WhatsAppButton = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isTouchDevice = () => window.matchMedia('(hover: none)').matches;

  const showTooltip = () => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    setTooltipVisible(true);
  };

  const hideTooltip = () => {
    hideTimer.current = setTimeout(() => setTooltipVisible(false), 150);
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault();
    showTooltip();
    hideTimer.current = setTimeout(() => {
      setTooltipVisible(false);
      window.open('https://wa.me/5515996719308', '_blank', 'noopener,noreferrer');
    }, 1200);
  };

  return (
    <div
      className="fixed z-50 flex items-center"
      style={{ bottom: '100px', right: '24px' }}
      onMouseEnter={() => !isTouchDevice() && showTooltip()}
      onMouseLeave={() => !isTouchDevice() && hideTooltip()}
    >
      <AnimatePresence>
        {tooltipVisible && (
          <motion.span
            key="tooltip-whatsapp"
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            transition={{ duration: 0.2 }}
            className="hidden md:block mr-3 whitespace-nowrap bg-[#0A1628] text-white text-xs font-medium px-3 py-1.5 rounded-lg shadow-lg pointer-events-none select-none relative"
          >
            Falar no WhatsApp
            <span className="absolute right-[-5px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-t-transparent border-b-transparent border-l-[#0A1628]" />
          </motion.span>
        )}
      </AnimatePresence>

      <motion.a
        href="https://wa.me/5515996719308"
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 200, damping: 15 }}
        className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full shadow-2xl hover:shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-all duration-300 cursor-pointer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Falar pelo WhatsApp"
        onTouchStart={handleTouchStart}
      >
        <i className="ri-whatsapp-line text-xl sm:text-[28px]"></i>
      </motion.a>
    </div>
  );
};

export default WhatsAppButton;
